module.exports = __webpack_public_path__ + "img/w-regions.fbe83b80.svg";